import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import Pagination from "@/components/base/Pagination";
import { newsList } from "@/mocks/news";
import { usePageMeta } from "@/hooks/usePageMeta";

const PAGE_SIZE = 4;

export default function NewsList() {
  usePageMeta({
    title: "影视资讯-555电影网",
    description: "555电影网影视资讯频道，提供档期前瞻、行业观察、影展资讯与口碑盘点等最新影视动态。",
    keywords: "影视资讯,电影资讯,电视剧资讯,影视动态,555电影网",
  });

  const [page, setPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil(newsList.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPages);
  const items = useMemo(
    () => newsList.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE),
    [safePage],
  );

  return (
    <div className="mx-auto max-w-page px-4 py-6 md:px-6 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "影视资讯" }]} />

      <div className="mt-4 rounded-lg border border-background-200 bg-background-100 px-5 py-5">
        <h1 className="font-heading text-2xl font-bold text-foreground-900 md:text-3xl">
          影视资讯
        </h1>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">
          聚焦影视行业动态、档期前瞻、影展资讯与口碑盘点，为你带来及时、有料的影视资讯内容。
        </p>
      </div>

      {newsList.length === 0 ? (
        <div className="mt-10 flex flex-col items-center rounded-lg border border-dashed border-background-300 bg-background-50 py-16">
          <div className="flex h-16 w-16 items-center justify-center text-foreground-300">
            <i className="ri-newspaper-line text-4xl"></i>
          </div>
          <p className="mt-4 text-sm text-foreground-600">暂时还没有资讯内容</p>
        </div>
      ) : (
        <>
          <div className="mt-6 space-y-4">
            {items.map((news) => (
              <article
                key={news.id}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-secondary-300"
              >
                <Link
                  to={`/news/detail/${news.id}`}
                  className="group grid grid-cols-1 gap-4 sm:grid-cols-[220px_1fr]"
                >
                  <div className="h-44 w-full overflow-hidden bg-background-200 sm:h-full">
                    <img
                      src={news.cover}
                      alt={`${news.title} 配图`}
                      title={`${news.title} - 555电影网`}
                      className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-5 sm:pr-6">
                    <div className="flex flex-wrap items-center gap-2 text-xs">
                      <span className="rounded bg-accent-50 px-2 py-0.5 font-medium text-accent-700">
                        {news.category}
                      </span>
                      <span className="text-foreground-400">{news.date}</span>
                      <span className="text-foreground-400">· {news.source}</span>
                    </div>
                    <h2 className="mt-2.5 font-heading text-lg font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-secondary-600">
                      {news.title}
                    </h2>
                    <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">
                      {news.summary}
                    </p>
                    <div className="mt-3 flex items-center gap-4 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line"></i>
                        {news.author}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {news.views.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>
          <Pagination currentPage={safePage} totalPages={totalPages} onChange={setPage} />
        </>
      )}
    </div>
  );
}